var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo-marking",attrs:{"src":require("../../../assets/images/logo-mark.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }